import { Form, Input, Modal, Select, Spin } from 'antd';
import React, { Component } from 'react';
import './style.css';

const { Option } = Select;

class GatewayCountryForm extends Component {
  componentDidUpdate = async (prevProps) => {
    const { data: pd } = prevProps;
    const { data: d, form } = this.props;

    if (d && (d.region_code !== pd.region_code || d.member_id !== pd.member_id)) {
      form.setFieldsValue(d);
    }
  };

  handleCancelModal = () => {
    const { onCancel, form } = this.props;

    form.resetFields();
    onCancel();
  };

  render() {
    const {
      visible,
      onCreate,
      form,
      flagCreateOrUpdateForm,
      countryList,
      gatewayList,
      loading,
    } = this.props;
    const { getFieldDecorator } = form;

    let okText = flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
    let title = okText + ' Gateway Route';

    return (
      <Modal
        visible={visible}
        title={title}
        okText={okText}
        cancelText="ยกเลิก"
        onCancel={this.handleCancelModal}
        onOk={onCreate}
        maskClosable={false}
        style={{ top: 20 }}
        loa
      >
        <Spin spinning={loading} tip="กำลังบันทึกข้อมูล...">
          <Form>
            {getFieldDecorator('member_id')(<Input type="hidden" />)}
            <Form.Item label="ประเทศ">
              {getFieldDecorator('region_code', {
                rules: [{ required: true, message: 'กรุณาเลือกประเทศ' }],
              })(
                <Select
                  showSearch
                  placeholder="กรุณาเลือกประเทศ"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  disabled={!flagCreateOrUpdateForm}
                >
                  {countryList.map((item, i) => (
                    <Option key={i} value={item.region_code}>
                      {item.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="Gateway">
              {getFieldDecorator('gateway', {
                rules: [{ required: true, message: 'กรุณาเลือก Gateway' }],
              })(
                <Select
                  showSearch
                  mode="multiple"
                  placeholder="กรุณาเลือก Gateway"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.handleChange}
                >
                  {gatewayList.map((item, i) => (
                    <Option key={i} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default Form.create({ name: 'gateway_country_form' })(GatewayCountryForm);



// WEBPACK FOOTER //
// ./src/containers/GatewayCountry/form.js